import { render } from "./MessagePopupApp.vue?vue&type=template&id=296a9b12"
import script from "./MessagePopupApp.vue?vue&type=script&lang=js"
export * from "./MessagePopupApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__